import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
  successRemoveForm,
} from './actions';

export function* requestOperacaoVazoesNaoAutorizadas({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'movimentacoesvazoesnaoautorizadas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteOperacaoVazaoNaoAutorizada({ payload }) {
  try {
    const { id, params, query } = payload;

    yield call(api.delete, `movimentacoesvazoesnaoautorizadas/${id}`, {
      params: query,
    });
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* store({ payload }) {
  try {
    const { operacaovazaonaoautorizada, params } = payload;

    yield call(
      api.post,
      'movimentacoesvazoesnaoautorizadas',
      operacaovazaonaoautorizada
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/operacaovazaonaoautorizada');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;

    const { data } = yield call(
      api.get,
      `movimentacoesvazoesnaoautorizadas/${id}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { operacaovazaonaoautorizada, params } = payload;

    yield call(
      api.put,
      'movimentacoesvazoesnaoautorizadas',
      operacaovazaonaoautorizada
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/operacaovazaonaoautorizada');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'movimentacoesvazoesnaoautorizadas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    const modItems = items.map((i) => ({
      ...i,
      datahorafinalmovimentacao: moment(i.datahorafinalmovimentacao).format(
        'DD/MM/YYYY HH:mm:ss'
      ),
      datahorainicialmovimentacao: moment(i.datahorainicialmovimentacao).format(
        'DD/MM/YYYY HH:mm:ss'
      ),
      datarecebimentomovimentacao: moment(i.datarecebimentomovimentacao).format(
        'DD/MM/YYYY HH:mm:ss'
      ),
    }));

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deletarCliente({ payload }) {
  try {
    const { data, params } = payload;

    let idoperacaoabastecimento = '';

    idoperacaoabastecimento = data.idmovimentacao;
    idoperacaoabastecimento = `${idoperacaoabastecimento}/${data.idposto}`;

    const justificativa = data.justificativa || '';

    const obj = {};
    obj.justificativa = justificativa;

    yield call(
      api.delete,
      `movimentacoesvazoesnaoautorizadas/${idoperacaoabastecimento}`,
      { params: obj }
    );
    yield put(successRemoveForm({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
    history.push('/operacaovazaonaoautorizada');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest(
    '@operacaovazaonaoautorizada/OPERACAOVAZOESNAOAUTORIZADAS_IN_REQUEST',
    requestOperacaoVazoesNaoAutorizadas
  ),
  takeLatest(
    '@operacaovazaonaoautorizada/DELETE_OPERACAOVAZAONAOAUTORIZADA',
    deleteOperacaoVazaoNaoAutorizada
  ),
  takeLatest(
    '@operacaovazaonaoautorizada/SUCCESS_REMOVE',
    requestOperacaoVazoesNaoAutorizadas
  ),
  takeLatest(
    '@operacaovazaonaoautorizada/SUCCESS_REMOVE_FORM',
    requestOperacaoVazoesNaoAutorizadas
  ),
  takeLatest(
    '@operacaovazaonaoautorizada/STORE_OPERACAOVAZAONAOAUTORIZADA',
    store
  ),
  takeLatest(
    '@operacaovazaonaoautorizada/FIND_OPERACAOVAZAONAOAUTORIZADA',
    find
  ),
  takeLatest(
    '@operacaovazaonaoautorizada/UPDATE_OPERACAOVAZAONAOAUTORIZADA',
    update
  ),
  takeLatest('@operacaovazaonaoautorizada/RECORD_FILTERING', applyedFilters),
  takeLatest(
    '@operacaovazaonaoautorizada/DELETE_OPERACAOVAZAONAOAUTORIZADA_CLIENTE',
    deletarCliente
  ),
]);
